class CartService {
  constructor() {
    this.queue = [];
    this.processing = false;

    this.drawer = document.querySelector('[data-cart-drawer]');
    this.countEl = document.querySelector('[data-cart-count]');

    this.bindEvents();
  }

  /* -----------------------------
    Events
  ------------------------------*/
  bindEvents() {

    document.addEventListener('submit', (e) => {
      if (e.target instanceof Element && e.target.closest('add-to-cart-component')) {
        e.preventDefault();
      }
    });

    // Listen for variant change events and update both variant ID and price
    document.addEventListener('variant:change', (e) => {
      const form = document.querySelector('.product-holistic__main form, form[data-ajax-cart-form]');
      if (!form) return;
    
      const variant = e.detail?.variant || e.detail?.resource;
      if (!variant) return;
    
      // Update variant ID in form
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
      }
      
      // Update price display if variant has price
      if (variant.price) {
        const priceElement = document.querySelector('.product-holistic__price-current');
        if (variant.price && priceElement && window.ShopMoneyFormat) {
        const amount = (variant.price / 100).toFixed(2);

          priceElement.textContent =
            window.ShopMoneyFormat.replace('{{amount}}', amount);
        }
      }
    });
    
    // Also listen for variant:update event (the standard event name used by the theme)
    document.addEventListener('variant:update', (e) => {
      const variant = e.detail?.resource || e.detail?.variant;
      if (!variant) return;
      
      // Update variant ID in form
      const form = document.querySelector('form[data-ajax-cart-form]') || 
                   document.getElementById('product-form') ||
                   document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = variant.id;
        }
      }
      
      // Update price display if variant has price
      if (variant.price) {
        const priceElement = document.querySelector('.product-holistic__price-current');
        if (priceElement) {
          // Format price (Shopify prices are in cents)
          const formattedPrice = '$' + (variant.price / 100).toFixed(2);
          priceElement.textContent = formattedPrice;
          console.log('[CartService] Price updated via variant:update to:', formattedPrice);
        }
      }
    });
    document.addEventListener('submit', (e) => {
      // For submit events, e.target is the form element
      const form = e.target instanceof HTMLFormElement && e.target.hasAttribute('data-ajax-cart-form')
        ? e.target
        : (e.target instanceof Element ? e.target.closest('[data-ajax-cart-form]') : null);
      if (!form) return;

      e.preventDefault();
      this.enqueue(() => this.addFromForm(form));
    });

    document.addEventListener('click', (e) => {
      /* OPEN CART */
     
     
      if (e.target.closest('[data-cart-open]')) {
        console.log('open drawer');
        e.preventDefault();
        this.openDrawer();
        return;
      }});
      document.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-cart-close]');
        if (!closeBtn) return;
      
        e.preventDefault();
        e.stopPropagation();
      
        this.closeDrawer();
      });
      
      document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-cart-remove]');
        if (!removeBtn) return;
      
        e.preventDefault();
        e.stopPropagation();
      
        const lineEl = removeBtn.closest('[data-line]');
        if (!lineEl) {
          console.error('[CartService] data-line not found for remove button');
          return;
        }
      
        const line = parseInt(lineEl.dataset.line, 10);
        
        if (isNaN(line) || line < 1) {
          console.error('[CartService] Invalid line number:', line);
          return;
        }
        
        console.log('[CartService] Removing cart item at line:', line);
        
        // Add visual feedback
        const cartItem = lineEl;
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
        
        window.CartService.enqueue(async () => {
          try {
            await window.CartService.change(line, 0);
          } catch (error) {
            console.error('[CartService] Error removing item:', error);
            cartItem.style.opacity = '1';
            cartItem.style.pointerEvents = '';
            alert(error.message || 'Failed to remove item from cart');
          }
        });
      });
      

    document.addEventListener('click', (e) => {
      const lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
    
      const line = lineEl.dataset.line;
      const qtyEl = lineEl.querySelector('.qty');
      if (!qtyEl) return;
      
      const currentQty = parseInt(qtyEl.textContent, 10);
      if (isNaN(currentQty)) return;
    
      if (e.target.matches('[data-qty-plus]') || e.target.closest('[data-qty-plus]')) {
        e.preventDefault();
        this.enqueue(() => this.change(line, currentQty + 1));
      }
    
      if (e.target.matches('[data-qty-minus]') || e.target.closest('[data-qty-minus]')) {
        e.preventDefault();
        if (currentQty > 1) {
          this.enqueue(() => this.change(line, currentQty - 1));
        }
      }
    });
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
    
      e.preventDefault();
    
      const variantId = btn.dataset.variantId;
      if (!variantId || !window.CartService) return;
    
      if (btn.dataset.adding === 'true') return;
    
      btn.dataset.adding = 'true';
      btn.disabled = true;
    
      const originalText = btn.textContent;
      btn.textContent = 'ADDING…';
    
      try {
        await window.CartService.addItems([
          { id: Number(variantId), quantity: 1 }
        ]);
    
        btn.textContent = 'ADDED ✓';
        btn.classList.add('added');
    
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = "ADD TO CART";
          btn.classList.remove('added');
          delete btn.dataset.adding;
        }, 1000);
    
      } catch (err) {
        console.error(err);
        btn.disabled = false;
        btn.textContent = originalText;
        delete btn.dataset.adding;
        alert('Failed to add product');
      }
    });
    
    
    // Handle cart recommendation add button
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-recommendation-item__add-btn');
      if (!btn) return;
      
      // Check if button is inside a form
      const form = btn.closest('form.cart-recommendation-item__form');
      if (!form) return;
      
      // Prevent default form submission
      e.preventDefault();
      e.stopPropagation();
      
      // Check if already processing
      if (btn.disabled || btn.hasAttribute('data-adding')) {
        return;
      }
      
      // Get variant ID from form
      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput || !variantIdInput.value) {
        console.error('[CartService] No variant ID found in cart recommendation form');
        return;
      }
      
      const variantId = variantIdInput.value;
      const originalText = btn.textContent;
      
      // Mark as processing
      btn.setAttribute('data-adding', 'true');
      btn.disabled = true;
      btn.textContent = 'ADDING...';
      
      window.CartService.enqueue(async () => {
        try {
          await window.CartService.addItems([
            { id: variantId, quantity: 1 }
          ]);
          
          // Show success state
          btn.textContent = 'ADDED!';
          btn.classList.add('added');
          
          // Reset button after delay
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
            btn.classList.remove('added');
            btn.removeAttribute('data-adding');
          }, 2000);
        } catch (error) {
          console.error('[CartService] Error adding cart recommendation item:', error);
          btn.disabled = false;
          btn.textContent = originalText;
          btn.removeAttribute('data-adding');
          alert(error.message || 'There was an error adding the product to cart. Please try again.');
        }
      });
    });
    
    // Also handle form submission for cart recommendation forms
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;
      
      // Check if it's a cart recommendation form
      if (form.classList.contains('cart-recommendation-item__form')) {
        e.preventDefault();
        e.stopPropagation();
        
        const btn = form.querySelector('.cart-recommendation-item__add-btn');
        if (btn) {
          // Trigger click handler
          btn.click();
        }
      }
    }, { capture: true });
    
    // Handle product-holistic buy-it-with add button
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-holistic__buy-it-with-add-btn');
      if (!btn) return;
      
      // Check if it's a bundle button (has specific IDs)
      const isBundleButton = btn.id === 'bundle-add-to-cart' || btn.id === 'bundle-add-to-cart-mobile';
      
      if (isBundleButton) {
        // Handle bundle add to cart
        e.preventDefault();
        e.stopPropagation();
        
        // Check if already processing
        if (btn.disabled || btn.hasAttribute('data-adding')) {
          return;
        }
        
        const originalText = btn.textContent;
        btn.setAttribute('data-adding', 'true');
        btn.disabled = true;
        btn.textContent = 'ADDING...';
        
        window.CartService.enqueue(async () => {
          try {
            const itemsToAdd = [];
            
            // Add main product first
            const mainProductVariantId = document.querySelector('form[data-ajax-cart-form] input[name="id"]');
            if (mainProductVariantId && mainProductVariantId.value) {
              itemsToAdd.push({
                id: mainProductVariantId.value,
                quantity: 1
              });
            }
            
            // Add checked bundle products
            const bundleCheckboxes = document.querySelectorAll('.product-holistic__buy-it-with-checkbox');
            bundleCheckboxes.forEach(checkbox => {
              if (checkbox.checked) {
                const productId = checkbox.dataset.productId;
                const variantSelect = document.querySelector(`.product-holistic__buy-it-with-variant[data-product-id="${productId}"]`);
                if (variantSelect) {
                  itemsToAdd.push({ id: variantSelect.value, quantity: 1 });
                } else {
                  const hiddenVariant = document.querySelector(`input[data-bundle-variant-id][data-product-id="${productId}"]`);
                  if (hiddenVariant) {
                    itemsToAdd.push({ id: hiddenVariant.value, quantity: 1 });
                  }
                }
              }
            });
            
            if (itemsToAdd.length > 0) {
              await window.CartService.addItems(itemsToAdd);
              
              // Show success state
              btn.textContent = 'ADDED!';
              btn.classList.add('added');
              
              // Reset button after delay
              setTimeout(() => {
                btn.disabled = false;
                btn.textContent = originalText;
                btn.classList.remove('added');
                btn.removeAttribute('data-adding');
              }, 2000);
            } else {
              throw new Error('No items selected to add to cart');
            }
          } catch (error) {
            console.error('[CartService] Error adding bundle to cart:', error);
            btn.disabled = false;
            btn.textContent = originalText;
            btn.removeAttribute('data-adding');
            alert(error.message || 'There was an error adding items to your cart. Please try again.');
          }
        });
      } else {
        // Regular add to cart button - check if it's in a form with data-ajax-cart-form
        // If so, let the form submission handler take care of it
        const form = btn.closest('form[data-ajax-cart-form]');
        if (form && btn.type === 'submit') {
          // Form submission will be handled by the form submit listener
          return;
        }
        
        // If it's a button not in a form, handle it directly
        if (btn.type === 'button') {
          e.preventDefault();
          e.stopPropagation();
          
          // Check if already processing
          if (btn.disabled || btn.hasAttribute('data-adding')) {
            return;
          }
          
          // Get variant ID from the form
          const form = document.querySelector('form[data-ajax-cart-form]');
          if (!form) {
            console.error('[CartService] No form found for product-holistic add to cart');
            return;
          }
          
          const variantIdInput = form.querySelector('input[name="id"]');
          if (!variantIdInput || !variantIdInput.value) {
            console.error('[CartService] No variant ID found in product form');
            return;
          }
          
          const quantityInput = form.querySelector('input[name="quantity"]');
          const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          
          const variantId = variantIdInput.value;
          const originalText = btn.textContent;
          
          btn.setAttribute('data-adding', 'true');
          btn.disabled = true;
          btn.textContent = 'ADDING...';
          
          window.CartService.enqueue(async () => {
            try {
              await window.CartService.addItems([
                { id: variantId, quantity: quantity }
              ]);
              
              // Show success state
              btn.textContent = 'ADDED!';
              btn.classList.add('added');
              
              // Reset button after delay
              setTimeout(() => {
                btn.disabled = false;
                btn.textContent = originalText;
                btn.classList.remove('added');
                btn.removeAttribute('data-adding');
              }, 2000);
            } catch (error) {
              console.error('[CartService] Error adding product to cart:', error);
              btn.disabled = false;
              btn.textContent = originalText;
              btn.removeAttribute('data-adding');
              alert(error.message || 'There was an error adding the product to cart. Please try again.');
            }
          });
        }
      }
    });
    
  }
  

  /* -----------------------------
    Queue (Race Condition Fix)
  ------------------------------*/
  enqueue(task) {
    this.queue.push(task);
    this.process();
  }

  async process() {
    if (this.processing || !this.queue.length) return;

    this.processing = true;
    await this.queue.shift()();
    this.processing = false;

    this.process();
  }

  /* -----------------------------
    Cart API
  ------------------------------*/
  async addFromForm(form) {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Check if this is a quick-add form (inside quick-add-component or has quick-add class)
    const isQuickAdd = form.closest('quick-add-component') !== null || 
                       form.closest('.quick-add') !== null ||
                       form.querySelector('.quick-add__button') !== null;
    
    // Check if this is from product detail page (product-holistic)
    const isProductDetailPage = form.closest('.product-holistic') !== null ||
                                form.closest('.product-holistic__main') !== null ||
                                document.querySelector('.product-holistic') !== null;
    
    // Check if this is a bundle form
    const isBundle = form.id === 'bundle-add-to-cart-form' || 
                     form.querySelector('#bundle-add-to-cart') !== null ||
                     form.closest('.product-holistic__buy-it-with') !== null ||
                     form.querySelector('.product-holistic__buy-it-with-add-btn') !== null;
    
    let source = 'product-form';
    if (isQuickAdd) {
      source = 'quick-add-button';
    } else if (isBundle) {
      source = 'product-holistic-bundle';
    } else if (isProductDetailPage) {
      source = 'product-holistic';
    }
    
    console.log('[CartService] Form source detection - isQuickAdd:', isQuickAdd, 'isProductDetailPage:', isProductDetailPage, 'isBundle:', isBundle, 'source:', source);
    
    // Get updated cart data
    let cart;
    try {
      const cartResponse = await fetch('/cart.js?' + Date.now());
      cart = await cartResponse.json();
    } catch (error) {
      console.error('[CartService] Error fetching cart:', error);
      cart = { item_count: 1, total_price: data.price || 0 };
    }

    // Dispatch CartAddEvent to trigger cart drawer opening (if not already open)
    try {
      const { CartAddEvent, CartUpdateEvent } = await import('@theme/events');
      
      const cartAddEvent = new CartAddEvent(
        {},
        variantId?.toString() || data.variant_id?.toString() || '',
        {
          source: source,
          itemCount: cart.item_count,
          totalPrice: cart.total_price,
          variantId: variantId?.toString() || data.variant_id?.toString() || ''
        }
      );
      document.dispatchEvent(cartAddEvent);
      console.log('[CartService] CartAddEvent dispatched for form submission, source:', source);
      
      // Wait a moment for cart drawer to start opening
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Dispatch CartUpdateEvent to refresh content (but don't open drawer again)
      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.sectionId || 
                       cartItemsComponent?.dataset?.sectionId || 
                       cartItemsComponent?.getAttribute('data-section-id') || '';
      
      const cartUpdateEvent = new CartUpdateEvent(
        {},
        sectionId && sectionId !== '' && sectionId !== 'cart-drawer-fallback' ? sectionId : null,
        {
          source: source,
          itemCount: cart.item_count,
          totalPrice: cart.total_price
        }
      );
      document.dispatchEvent(cartUpdateEvent);
    } catch (importError) {
      console.warn('[CartService] Could not import events, using CustomEvent fallback');
      // Fallback: use CustomEvent
      const cartAddEvent = new CustomEvent('cart:add', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: variantId?.toString() || data.variant_id?.toString() || '',
          data: {
            source: source,
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            variantId: variantId?.toString() || data.variant_id?.toString() || ''
          }
        }
      });
      document.dispatchEvent(cartAddEvent);
      
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: variantId?.toString() || data.variant_id?.toString() || '',
          data: {
            source: source,
            itemCount: cart.item_count,
            totalPrice: cart.total_price
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);
    }
    
    // Refresh content after events are dispatched (but don't open drawer)
    await this.refresh(false);
  }
  async addItems(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Get updated cart data
    let cart;
    try {
      const cartResponse = await fetch('/cart.js?' + Date.now());
      cart = await cartResponse.json();
    } catch (error) {
      console.error('[CartService] Error fetching cart:', error);
      cart = { item_count: items.length, total_price: 0 };
    }
    
    // Determine source from context
    const source = 'cart-recommendations'; // Default, can be overridden by caller
    
    // Dispatch CartAddEvent to trigger cart drawer opening and refresh
    try {
      const { CartAddEvent, CartUpdateEvent } = await import('@theme/events');
      
      // Get the first item's variant ID for the event
      const variantId = items[0]?.id?.toString() || data.variant_id?.toString() || '';
      
      const cartAddEvent = new CartAddEvent(
        {},
        variantId,
        {
          source: source,
          itemCount: cart.item_count,
          totalPrice: cart.total_price,
          variantId: variantId
        }
      );
      document.dispatchEvent(cartAddEvent);
      console.log('[CartService] CartAddEvent dispatched for addItems');
      
      // Wait a moment for drawer to open
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // Dispatch CartUpdateEvent to refresh cart content
      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.sectionId || 
                       cartItemsComponent?.dataset?.sectionId || 
                       cartItemsComponent?.getAttribute('data-section-id') || '';
      
      const cartUpdateEvent = new CartUpdateEvent(
        {},
        sectionId && sectionId !== '' && sectionId !== 'cart-drawer-fallback' ? sectionId : null,
        {
          source: source,
          itemCount: cart.item_count,
          totalPrice: cart.total_price
        }
      );
      document.dispatchEvent(cartUpdateEvent);
      console.log('[CartService] CartUpdateEvent dispatched for addItems');
      
    } catch (importError) {
      console.warn('[CartService] Could not import events, using CustomEvent fallback');
      
      // Fallback with CustomEvent
      const variantId = items[0]?.id?.toString() || data.variant_id?.toString() || '';
      const cartAddEvent = new CustomEvent('cart:add', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: variantId,
          data: {
            source: source,
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            variantId: variantId
          }
        }
      });
      document.dispatchEvent(cartAddEvent);
      
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: null,
          data: {
            source: source,
            itemCount: cart.item_count,
            totalPrice: cart.total_price
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);
    }
  
    // Refresh content after events are dispatched (but don't open drawer - CartAddEvent already opened it)
    await this.refresh(false);
  }
  

  async change(line, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || errorData.message || `HTTP error! status: ${response.status}`);
    }

    // Get updated cart data
    let cart;
    try {
      const cartResponse = await fetch('/cart.js?' + Date.now());
      cart = await cartResponse.json();
    } catch (error) {
      console.error('[CartService] Error fetching cart:', error);
      cart = { item_count: 0, total_price: 0 };
    }

    // Dispatch CartUpdateEvent to refresh cart content
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      
      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.sectionId || 
                       cartItemsComponent?.dataset?.sectionId || 
                       cartItemsComponent?.getAttribute('data-section-id') || '';
      
      const cartUpdateEvent = new CartUpdateEvent(
        {},
        sectionId && sectionId !== '' && sectionId !== 'cart-drawer-fallback' ? sectionId : null,
        {
          source: 'cart-remove',
          itemCount: cart.item_count,
          totalPrice: cart.total_price
        }
      );
      document.dispatchEvent(cartUpdateEvent);
      console.log('[CartService] CartUpdateEvent dispatched for remove/change');
    } catch (importError) {
      console.warn('[CartService] Could not import events, using CustomEvent fallback');
      
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: null,
          data: {
            source: 'cart-remove',
            itemCount: cart.item_count,
            totalPrice: cart.total_price
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);
    }

    // Also refresh using section rendering if available
    await this.refresh();
  }

  /* -----------------------------
    Section Rendering
  ------------------------------*/
  async refresh(openDrawer = false) {
    try {
      const res = await fetch(
        `${window.location.pathname}?sections=cart-drawer`
      );
    
      if (!res.ok) {
        console.warn('[CartService] Section rendering failed, using event-based refresh');
        return;
      }
    
      const sections = await res.json();
      const html = sections['cart-drawer'];
    
      if (!html) {
        console.warn('[CartService] No cart-drawer section in response');
        return;
      }
    
      const doc = new DOMParser().parseFromString(html, 'text/html');
      
      // Try to find cart-drawer-component or cart-items-component
      const newDrawer = doc.querySelector('cart-drawer-component') || 
                        doc.querySelector('[data-cart-drawer]') ||
                        doc.querySelector('cart-items-component');
      
      if (newDrawer) {
        // Find existing drawer component
        const existingDrawer = document.querySelector('cart-drawer-component');
        const existingCartItems = document.querySelector('cart-items-component');
        
        if (existingCartItems && newDrawer.querySelector('cart-items-component')) {
          // Update cart-items-component content
          const newCartItems = newDrawer.querySelector('cart-items-component');
          const newWrapper = newCartItems.querySelector('.cart-items__wrapper');
          const existingWrapper = existingCartItems.querySelector('.cart-items__wrapper');
          
          if (newWrapper && existingWrapper) {
            existingWrapper.innerHTML = newWrapper.innerHTML;
          } else if (newCartItems) {
            // Replace entire component content
            existingCartItems.innerHTML = newCartItems.innerHTML;
          }
        } else if (existingDrawer && newDrawer.tagName === 'CART-DRAWER-COMPONENT') {
          // Replace entire drawer
          const newInner = newDrawer.querySelector('.cart-drawer__inner');
          const existingInner = existingDrawer.querySelector('.cart-drawer__inner');
          
          if (newInner && existingInner) {
            existingInner.innerHTML = newInner.innerHTML;
          }
        }
      }
    
      // Don't add cart-open class here - let the cart-drawer-component handle opening via events
      // The openDrawer parameter is kept for backward compatibility but shouldn't trigger opens
    } catch (error) {
      console.error('[CartService] Error refreshing cart:', error);
    }
  }
  
  dispatchEvents(cart, variantId) {
    document.dispatchEvent(new CustomEvent('cart:add', {
      bubbles: true,
      detail: { variantId, cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: cart
    }));
  }

  openDrawer(cart) {
    document.dispatchEvent(new CustomEvent('cart:open', {
      bubbles: true,
      detail: cart
    }));

    document.body.classList.add('cart-open');

    const toggle = document.querySelector('[data-cart-toggle]');
    if (toggle) toggle.click();
  }

  async updateCount() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    if (this.countEl) {
      this.countEl.textContent = cart.item_count;
    }
  }


  closeDrawer() {
    document.body.classList.remove('cart-open');
  }
    
}

// Prevent default form submission for add-to-cart forms that don't have ajax handlers
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (form && form instanceof HTMLFormElement && form.matches('[data-type="add-to-cart-form"]')) {
    // Only prevent if it doesn't have data-ajax-cart-form (which is handled above)
    if (!form.hasAttribute('data-ajax-cart-form')) {
      e.preventDefault();
    }
  }
});


/* -----------------------------
  Init
------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  window.CartService ||= new CartService();
});
